import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import * as yup from 'yup';
import { Formik } from 'formik';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { closePopup } from '../../actions/uiActions';
import { updatePresentation } from '../../actions/presentationActions';
import { SeparateFileNameAndExtension } from '../../components/utilities/helperFunctions';

class UpdatePresentation extends React.Component {
    state = {
        name: "",
        file: null
    }

    handleClick = (event) => {
        event.preventDefault();
        this.props.closePopup();
    }

    handleSubmit = (event) => {
        if (event.preventDefault !== undefined) { event.preventDefault(); }
        const data = new FormData();
        if (this.state.name.length > 0) {
            data.append('file', this.state.file, this.state.name);
        } else {
            data.append('file', this.state.file);
        }
        data.append('presentationId', this.props.popupInfo);
        this.props.updatePresentation(data);
    }

    onDrop(file, values) {
        if (file.length > 0) {
            let uploadedFileName = file[0]["name"]
            let fileName = SeparateFileNameAndExtension(uploadedFileName)["name"]
            let currentFileName = (this.state.name !== "") ? this.state.name : fileName

            values["name"] = fileName

            this.setState({
                file: file[0],
                name: currentFileName
            });
        } else {
            this.props.showMessage("File Extension was not .PPTX or .XLSX, Please Try Again", false)
        }
    }

    render() {
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogContent id="alert-dialog-description" className="uploadPOP">
                <Formik
                    initialValues={{
                        name: ''
                    }}
                    onSubmit={this.handleSubmit}
                    validationSchema={yup.object().shape({ name: yup.string().required('Required') })}
                >
                    {({
                        values,
                        handleChange,
                        errors,
                        setFieldTouched,
                        touched,
                        handleSubmit
                    }) => (
                        <form>
                            <div className="passwordResetbox">
                                <div className="checkOut">
                                    <h4>Update Story Template</h4>
                                </div>
                                <div className="uploadOut">
                                    <Dropzone onDrop={(file) => {
                                        this.onDrop(file, values)
                                    }} id="dropzone">
                                        {({getRootProps, getInputProps}) => (
                                            (this.state.file !== null) ? 
                                            (<div id="dropzone" {...getRootProps()}>
                                                <h5>Current File: {this.state.file.name}</h5>
                                                <input {...getInputProps()} />
                                            </div>) : 
                                            (<div id="dropzone" {...getRootProps()}>
                                                <h5>Drop or Click Here to Upload File</h5>
                                                <input {...getInputProps()} />
                                            </div>)
                                        )}
                                    </Dropzone>
                                    <AddPhotoAlternateIcon />
                                </div>
                                <div className="adminSelectbox">
                                    {errors.name && touched.name && (
                                        <Typography style={{ fontSize: 15, color: 'red' }}>
                                            {errors.name}
                                        </Typography>
                                    )}
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        className="btn"
                                        onClick={(e) => handleSubmit(e)}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, updatePresentation }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePresentation)